import { Component, Input, OnChanges } from '@angular/core';
import { TGridOptions } from './grid-consts';

@Component({
    selector: 'pp-grid',
    templateUrl: './grid.component.html',
    styleUrls: ['./grid.component.scss'],
    standalone: false
})
export class GridComponent implements OnChanges {
  @Input() ppOptions: TGridOptions;

  gridClass: {
    [className: string]: string | boolean;
  };

  constructor() {}

  ngOnChanges() {
    this.gridClass = {
      [this.ppOptions.bodyClass]: this.ppOptions.bodyClass,
      'settingsSection__body-padding': this.ppOptions.bodyPadding,
    };
  }
}
